import * as z from 'zod';

import { dateTime } from '@/_shared';

const yyyyMmDdRegex = /^\d{4}-\d{2}-\d{2}$/;

export const calendarDateSchema = z.string().regex(yyyyMmDdRegex, { message: 'Invalid Date' });
export type CalendarDateSchema = z.infer<typeof calendarDateSchema>;

export function strToDate(dateStr: CalendarDateSchema | null | undefined) {
  if (dateStr && dateStr !== null) {
    return new Date(`${dateStr}T00:00:00Z`);
  }
  return null;
}

export function DateToStr(dateObj: Date | null): CalendarDateSchema | null {
  if (dateObj && dateObj !== null) {
    return dateTime.format(dateObj, 'YYYY-MM-DD');
  }
  return null;
}
